<template>
    <div class="serviceDetailContent" v-if="goodsDetailData.goods_name">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>商品详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 商品信息 -->
        <div class="detailBox spb">
            <div class="detailImgBoxContent">
                <div class="detailImgBox">
                    <el-image v-if="goodsDetailData.goods_img" :src="goodsDetailData.goods_img[goodsImgActive]" fit="contain" :preview-src-list="goodsDetailData.goods_img" :initial-index="goodsImgActive" class="detailImg"></el-image>
                </div>
                <div class="thumbnailBox">
                    <el-image :src="require('@/assets/icon/left.png')" fit="cover" class="direction" @click="directionTap(0)"></el-image>
                    <div class="thumbnailPos">
                        <div class="thumbnailList" :style="{left: left + 'px'}">
                            <el-image v-for="(item,index) in goodsDetailData.goods_img" :key="index" :src="item" fit="cover" :class="['thumbnail',goodsImgActive == index ? 'thumbnailOn' : '']" @click="goodsImgActive = index" />
                        </div>
                    </div>
                    <el-image :src="require('@/assets/icon/right.png')" fit="cover" class="direction" @click="directionTap(1)"></el-image>
                </div>
            </div>
            <div class="detailData">
                <div class="flex">
                    <div class="goodsName">{{ goodsDetailData.goods_name }}</div>
                    <div class="copyBtn" @click="copyClick(message)">复制高佣链接</div>
                </div>
                <div class="align">
                    <div class="goodsTag">茶</div>
                </div>
                <div class="goodsItem">
                    <div class="goodsTitle">到手价</div>
                    <div class="align">
                        <div class="current"><span>￥</span>{{ goodsDetailData.skus[goodsDetailData.active].price }}</div>
                        <div class="ordinary">日常价￥{{ goodsDetailData.skus[goodsDetailData.active].original_price }}</div>
                    </div>
                </div>
                <div class="spb" v-for="(item,index) in JSON.parse(JSON.stringify(goodsDetailData.sku_attrs))" :key="index">
                    <div class="goodsItem">
                        <div class="goodsTitle">{{ item.attr_key }}</div>
                        <el-select v-model="item.attr_value[item.active]" placeholder="请选择" size="small" class="goodsSearch" @change="selChange($event,index)">
                            <el-option v-for="(el,ii) in JSON.parse(JSON.stringify(item.attr_value))" :key="ii" :label="el" :value="el" />
                        </el-select>
                    </div>
                    <div class="sales" v-if="index == (goodsDetailData.sku_attrs.length - 1)">总销量 {{ goodsDetailData.sales }}</div>
                </div>
                <div class="goodsPriceBox align">
                    <div class="goodsPriceItem">
                        <div class="goodsPriceTitle">预估每单赚</div>
                        <div class="goodsPrice"><span>￥</span>{{ goodsDetailData.skus[goodsDetailData.active].yugu }}</div>
                    </div>
                    <div class="goodsPriceItem" style="padding-left: 24px;border-left: 1px solid #EEF0F3;">
                        <div class="goodsPriceTitle">星选高佣</div>
                        <div class="goodsPrice">{{ goodsDetailData.commission }}%</div>
                    </div>
                    <div class="goodsPriceItem">
                        <div class="goodsPriceTitle" style="color:#969697;">公开佣金</div>
                        <div class="goodsPrice" style="color:#969697;">{{ goodsDetailData.commission1 }}%</div>
                    </div>
                </div>
                <div class="detailBtn" style="margin-top: 34px;" @click="detailBtnTap">上架到橱窗</div>
            </div>
            <div class="storeData" style="border: none;"></div>
        </div>
        <!-- 详情图 -->
        <div class="courseBox">
            <div class="courseTabBox align">
                <div :class="['courseTab',active == index ? 'courseTabOn' : '']" v-for="(item,index) in courseTabData" :key="index" @click="courseTabTap(index)">{{ item }}</div>
            </div>
            <div class="courseImgBox">
                <div v-html="goodsDetailData.detail"></div>
                <!-- <el-image v-for="(item,index) in courseImgData" :key="item" :src="item" lazy :preview-src-list="courseImgData" :initial-index="index" class="courseImg"></el-image> -->
            </div>
        </div>
    </div>
</template>
<script>
import useClipboard from "vue-clipboard3";
const { toClipboard } = useClipboard();
    export default{
        data(){
            return{
                userDetail: 0,
                goodsDetailData: {},
                message: '粘贴粘贴',
                left: 0,
                directionBoole: true,
                goodsImgActive: 0,
                active: 0,
                courseTabData: ['商品详情'],
                value: '',
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getGoodsDetail()
        },
        methods: {
            // 获取商品详情
            getGoodsDetail(){
                this.request.get("index/goods/detail",{
                    params:{
                        id: this.$route.query.id
                    }
                })
                .then(res=>{
                    res.data.active = 0
                    this.goodsDetailData = res.data
                })
            },
            // 商品图左右滑动
            directionTap(e){
                var that = this
                if(that.directionBoole && this.goodsDetailData.goods_img.length > 2){
                    that.directionBoole = false
                    if(e){
                        that.left = -74
                        that.goodsDetailData.goods_img.unshift(that.goodsDetailData.goods_img[that.goodsDetailData.goods_img.length - 1])
                        var time = setInterval(function(){
                            that.left = that.left + 2
                            if(that.left == 0){
                                clearInterval(time)
                                that.goodsDetailData.goods_img.pop()
                                that.directionBoole = true
                            }
                        },1)
                    }else{
                        that.goodsDetailData.goods_img.push(that.goodsDetailData.goods_img[0])
                        var time = setInterval(function(){
                            that.left = that.left - 2
                            if(that.left == -74){
                                clearInterval(time)
                                that.goodsDetailData.goods_img.shift()
                                that.left = 0
                            }
                        },1)
                    }
                }
            },
            // 复制高佣链接
            copyClick(e) {
                toClipboard(e);
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 规格与价格匹配封装
            getPrice(){
                let name = ''
                this.goodsDetailData.sku_attrs.map((el,index) => {
                    name = name + el.attr_value[el.active]
                })
                this.goodsDetailData.skus.map((el,index) => {
                    if(el.spec_name == name){
                        this.goodsDetailData.active = index
                    }
                })
            },
            // 选择规格
            selChange(e,i){
                this.goodsDetailData.sku_attrs[i].attr_value.map((el,index) => {
                    if(el == e){
                        this.goodsDetailData.sku_attrs[i].active = index
                    }
                })
                this.getPrice()
                console.log(e,i)
                console.log(this.goodsDetailData)
            },
            // tab切换
            courseTabTap(e){
                this.active = e
            },
            // 跳转提交表单
            detailBtnTap(){
                if(!this.userDetail){
                    this.$router.push({ path:'/login/login' })
                    return
                }
                this.$router.push({ path:'/service/form', query:{id:this.$route.query.id,type: '1'} })
            }
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/detail.less';
</style>